import { GridService } from '../shared/grid/grid.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SamplingEquipment } from '../models/samplingEquipment.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SamplingEquipmentService extends GridService<SamplingEquipment> {

    constructor(http: HttpClient) {
        super('SamplingEquipment', http);
    }

    createRange(payload: SamplingEquipment[]): Observable<SamplingEquipment[]> {
        return this.http.post<SamplingEquipment[]>(
            this.getApiUrl(`${this.controllerName}/CreateRange`), payload);
    }
}
